import ShiftModel from 'models/ShiftModel';

ShiftStore.allShifts = [];

ShiftStore.dispatchToken = MakeShiftEmployeeDispatcher.register(ShiftStore.dispatchCallback);

ShiftStore.setUnavailables = function (data) {
  ShiftStore.unavailables = data;
};

ShiftStore.onShiftsHandler = function (shiftData, response) {
  ShiftStore.reset(response.data.scheduled_shifts);
  OffersStore.reset(response.data.offered_shifts);
  ShiftStore.trigger('shifts:load:success');
};

ShiftStore.onShiftsError = function (error) {
  ShiftStore.trigger('shifts:load:error', error);
};

ShiftStore.onAllShiftsHandler = function (shiftData, response) {
  OffersStore.setAllOffers(response.data.offered_shifts);
  ShiftStore.allShifts = response.data.scheduled_shifts;
  ShiftStore.trigger('all:shifts:load:success', response);
};

ShiftStore.onAllShiftsError = function (error) {
  ShiftStore.trigger('shifts:load:error', error);
};

ShiftStore.onShiftByIDHandler = function (collection, response) {
  ShiftStore.trigger('shift_by_id:load:success', collection, response);
};

ShiftStore.onShiftByIDError = function (collection, error) {
  ShiftStore.trigger('shift_by_id:load:error', error);
};

ShiftStore.getAllShiftsUntilTheEndOfTime = function () {
  return ShiftStore.allShifts;
};

ShiftStore.getAllShifts = function (startDate, endDate) {
  if (Utils.isNotDefined(startDate)) {
    startDate = moment(Utils.getCurrentDate())
      .startOf('month')
      .format();
  }

  if (Utils.isNotDefined(endDate)) {
    endDate = moment(startDate)
      .endOf('month')
      .format();
  }

  const data = this.models;
  const rtnData = [];
  data.map((obj) => {
    if (!Utils.isNotDefined(obj.attributes) && !Utils.isNotDefined(obj.attributes.start_time)) {
      const compareDate = moment(obj.attributes.start_time).tz(obj.attributes.time_zone);
      const between = Utils.isDateBetweenOrSame(compareDate, startDate, endDate);
      if (between) {
        rtnData.push(obj.present());
      }
    }
  });

  return rtnData;
};

ShiftStore.addExchangeToShift = function (exchangeData) {
  const shift = ShiftStore.get(exchangeData.shift_id);

  const allShift = _.find(ShiftStore.allShifts, shift => shift.id == exchangeData.shift_id);

  if (!Utils.isNotDefined(shift)) {
    shift.attributes.exchanges.push(exchangeData);
  }
  if (!Utils.isNotDefined(allShift)) {
    allShift.exchanges.push(exchangeData);
  }
};

ShiftStore.removeExchangesFromShift = function (shiftID, exchangeID) {
  const shift = ShiftStore.get(shiftID);

  const allShift = _.find(ShiftStore.allShifts, shift => shift.id == shiftID);

  if (shift) {
    var len = shift.attributes.exchanges.length;
    for (var i = 0; i < len; i++) {
      if (parseInt(shift.attributes.exchanges[i].id, 10) === parseInt(exchangeID, 10)) {
        shift.attributes.exchanges.splice(i, 1);
        break;
      }
    }
  }

  if (allShift) {
    var len = allShift.exchanges.length;
    for (var i = 0; i < len; i++) {
      if (parseInt(allShift.exchanges[i].id, 10) === parseInt(exchangeID, 10)) {
        allShift.exchanges.splice(i, 1);
        break;
      }
    }
  }
};

ShiftStore.getAllShiftsByShiftId = function (id) {
  let shift = null;
  const len = ShiftStore.allShifts.length;
  for (let i = 0; i < len; i++) {
    if (ShiftStore.allShifts[i].id == id) {
      shift = ShiftStore.allShifts[i];
      break;
    }
  }
  return shift;
};

ShiftStore.getShiftByDate = function (date) {
  let shift = null;
  const len = this.allShifts.length;
  for (let i = 0; i < len; i++) {
    if (
      moment(this.allShifts[i].start_time)
        .tz(this.allShifts[i].time_zone)
        .format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
    ) {
      shift = this.allShifts[i];
      break;
    }
  }
  return shift;
};

ShiftStore.getShiftsByDate = function (date) {
  const shifts = [];
  const len = this.allShifts.length;
  for (let i = 0; i < len; i++) {
    if (
      moment(this.allShifts[i].start_time)
        .tz(this.allShifts[i].time_zone)
        .format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
    ) {
      shifts.push(this.allShifts[i]);
    }
  }
  return shifts;
};

ShiftStore.onShiftByDateHandler = function (collection, response) {
  const len = collection.data.scheduled_shifts.length;
  for (let i = 0; i < len; i++) {
    const model = new ShiftModel(collection.data.scheduled_shifts[i]);
    ShiftStore.add(model);
  }
  ShiftStore.trigger('shift_by_date:load:success', ShiftStore, collection.data.scheduled_shifts);
};

ShiftStore.onShiftByDateError = function (error) {
  ShiftStore.trigger('shift_by_date:load:error', error);
};

ShiftStore.getOfferableShifts = function (selectedExchangeShift) {
  const eligibleOfferJobSiteIds = _.findWhere(ExchangesStore.users, {
    id: selectedExchangeShift.user_id,
  }).job_site_ids;
  const eligibleOfferShifts = ShiftStore.filter(
    offerableShift => offerableShift.get('job_site_id') === null
      || _.contains(eligibleOfferJobSiteIds, offerableShift.get('job_site_id')),
  ).map(shift => shift.attributes);

  return eligibleOfferShifts;
};
